var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgItemname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.19897V6H14.25V9.19897C14.25 11.5801 14.25 12.7706 13.5178 13.5103C12.7856 14.25 11.607 14.25 9.24997 14.25H8.00003C5.64298 14.25 4.46446 14.25 3.73223 13.5103C3 12.7706 3 11.5801 3 9.19897Z",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 6L3.54086 4.84616C3.96034 3.95129 4.17007 3.50385 4.59519 3.25193C5.02031 3 5.56563 3 6.65625 3H10.5938C11.6844 3 12.2297 3 12.6548 3.25193C13.0799 3.50385 13.2897 3.95129 13.7091 4.84616L14.25 6",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.25H9.75",
    stroke: "#626F86",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemname);
export default __webpack_public_path__ + "static/media/itemname.288cc78e68fa22c4ad7c1cf75be2d9fb.svg";
export { ForwardRef as ReactComponent };